import { IconInfoCircle } from '@justeattakeaway/pie-icons-react';
import { PIEComponentUtil } from '@src/shared/components/PIEComponentUtil';
import PIETag, { ETagsColorType } from '@src/shared/components/PIETag';
import React, { FC } from 'react';
import { globalStyles } from 'snacks-design-system';
import style from './TagDue.module.scss';
import { useTranslation } from 'react-i18next';

const { xdsSpacingB } = globalStyles;

interface ITagDueProps {
  dueTime?: string;
}
const TagDue: FC<ITagDueProps> = ({ dueTime }) => {
  const { t } = useTranslation();
  return (
    <PIETag mode={ETagsColorType.Brand05}>
      <PIEComponentUtil paddingX={xdsSpacingB}>
        {/* <IconInfoCircle className={style.icon} size="xs" style={{ marginRight: '4px' }} /> */}
        {t('order.status_DUE')} {dueTime ? `${dueTime}` : ''}
      </PIEComponentUtil>
    </PIETag>
  );
};

export default TagDue;
